module.exports = __webpack_public_path__ + "body-special-bg-shape-01.png?d639c3fdff2f43b4e9f442e0aa3551af";